// Pure geometry helpers for the AOE2 crop-box editor.
//
// Converts between source-video pixel coordinates and display-element
// pixel coordinates, and produces inline style objects for the crop
// overlay box. No DOM, no Stimulus — functions take explicit dimensions
// rather than reading the DOM, so every branch is unit-testable.

// Convert a source-video x/y position to display (rendered <video>) px.
// `displayWidth` / `displayHeight` are the rendered element dimensions;
// `sourceWidth` / `sourceHeight` are the native video dimensions.
export function sourcePxToDisplay(sourceX, sourceY, { displayWidth, displayHeight, sourceWidth, sourceHeight }) {
  const scaleX = displayWidth / sourceWidth
  const scaleY = displayHeight / sourceHeight
  return {
    x: sourceX * scaleX,
    y: sourceY * scaleY,
  }
}

// Inverse: display-element px → source-video px.
export function displayToSourcePx(displayX, displayY, { displayWidth, displayHeight, sourceWidth, sourceHeight }) {
  const scaleX = sourceWidth / displayWidth
  const scaleY = sourceHeight / displayHeight
  return {
    x: displayX * scaleX,
    y: displayY * scaleY,
  }
}

// Compute an inline style object for the crop overlay box given a source-px
// crop rect `{x, y, w, h}` and a uniform display scale factor.
// `scale` = displayWidth / sourceWidth (same scale used for the <video>).
export function cropBoxStyle(rect, scale) {
  return {
    position: "absolute",
    left: `${rect.x * scale}px`,
    top: `${rect.y * scale}px`,
    width: `${rect.w * scale}px`,
    height: `${rect.h * scale}px`,
  }
}

// Convert a pointer delta (in display px) to a source-px delta.
// Useful when dragging the crop box — mouse deltas are in display space
// but the crop rect is stored in source space.
export function pointerDeltaToSourcePx(deltaDisplayX, deltaDisplayY, { displayWidth, displayHeight, sourceWidth, sourceHeight }) {
  return displayToSourcePx(deltaDisplayX, deltaDisplayY, {
    displayWidth,
    displayHeight,
    sourceWidth,
    sourceHeight,
  })
}
